export default __webpack_public_path__ + "static/media/resume0821.200e0309.pdf";